<template>
  <div>
    <!-- NAVBAR-->
    <nav>
      <Navbar :navbar="navbar"></Navbar>
    </nav>

    <main :class="{
        'ml-10': $vuetify.display.mdAndUp,
        'ml-n4': $vuetify.display.smAndDown,
        'me-10': $vuetify.display.mdAndUp,
        'me-n4': $vuetify.display.smAndDown,
      }">
      <!-- title -->
      <v-container fluid>
        <v-card
          flat
          class="mx-auto"
          max-width="660"
        >
          <v-row class="ml-4 mt-6 mb-2">
            <v-col cols="6">
              <v-row>
                <v-img
                  src="@/assets/logo/logo_blue21.png"
                  cover
                  max-width="240"
                  max-height="60"
                ></v-img>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <!-- New / Edit -->
            <h1 class="text-h5 titleH1 ml-8">
              {{ $t("common." + $route.meta.title) }}
            </h1>
          </v-row>
          <v-alert
            style="line-height: 1.5"
            type="info"
            class="mt-4"
            border="start"
            variant="tonal"
          >{{ $t("user.titleHelpChangePassword") }}</v-alert>

          <!-- FORM -->
          <v-form
            v-model="formValid"
            ref="form"
          >
            <v-card flat>
              <Password :password="password"></Password>
            </v-card>

            <!-- ///////////////////////////////////////////////////////////////////////////////////////////////// -->
            <!-- snackbar -->
            <v-snackbar
              v-model="snackbar.show"
              location="top"
              :color="snackbar.color"
              :timeout="snackbar.timeout"
            >{{ snackbar.text }}</v-snackbar>

            <!-- DIALOG -->

            <!-- BUTTOM-->
            <v-card flat>
              <MainButton
                :mainButton="mainButton"
                @save="save"
              ></MainButton>
            </v-card>
          </v-form>
        </v-card>
      </v-container>
    </main>
  </div>
</template>

<script>
// import i18n from "@/i18n.js";

import Password from "@/app/1_access/components/Password.vue";
//
import Navbar from "@/app/2_common/components/page/Navbar.vue";
import Dialog from "@/app/2_common/components/page/Dialog.vue";
import MainButton from "@/app/2_common/components/page/MainButton.vue";

// services / helpers
import { api } from "@/services.js";

export default {
  name: "ResetPassword",
  components: {
    Password,
    //
    Navbar,
    Dialog,
    MainButton
  },
  ////////
  data() {
    return {
      token: "",
      email: "",
      //
      // standard
      formValid: true,
      goBackOk: false,
      // Help
      titleHelpChangePassword: true,
      // Setting / prefer
      //
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      ///  PROPS     //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // Props Password
      password: {
        password: "",
        passwordConfirm: "",
        showPassword: false,
        showPasswordConfirm: false
      },
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      ///  PROPS Dialog MainButton  Navbar  ///////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // Props Dialog
      dialog: {
        show: false,
        title: "dialog",
        text: ""
      },
      // Props MainButton
      mainButton: {
        btnSaveDisabled: false,
        btnCancelShow: false
      },
      // Props Navbar
      navbar: {
        menu: [
          {
            text: "Help",
            icon: "mdi-help-circle-outline",
            action: "",
            route: ""
          }
        ]
      },
      // snackbar
      snackbar: {
        show: false,
        color: "",
        text: "",
        timeout: 3000
      },
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      ///  RULES     //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      rules: {
        required: value => !!value || this.$t("rules.Required Field")
        //
      }
    };
  },
  //////////
  methods: {
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///  JS     /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /// NAVBAR //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///  MAIN BUTTOM  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // save
    async save() {
      if (!this.goBackOk) {
        let valid = await this.testFormValid();
        if (!valid) {
          // snackbar
          window.scrollTo(0, 0);
          this.snackbar.color = "warning";
          window.scrollTo(0, 0);
          this.snackbar.text = this.$t("message.alertTyping");
          this.snackbar.show = true;
          //
          return;
        }
      }
      //
      //
      if (this.password.password != this.password.passwordConfirm) {
        window.scrollTo(0, 0);
        this.snackbar.color = "warning";
        this.snackbar.text = this.$t("message.The second Password does not match with the first password");
        this.snackbar.show = true;
        //
        return;
      }
      this.mainButton.btnSaveDisabled = true;
      //
      this.resetPassword();
    },
    //
    /////////////////
    async testFormValid() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return false;
      } else {
        return true;
      }
    },

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///  ROUTER  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // goBack(
    goBack() {
      this.snackbar.show = false;
      this.goBackOk = true;
      this.$router.push({ name: "login" });
    },

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///  STORE  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /// MESSAGE //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    snackbarTimeout(timeout) {
      this.mainButton.btnSaveDisabled = false;
      this.snackbar.show = true;
      this.snackbar.timeout = timeout;
      setTimeout(() => {
        this.goBack();
      }, this.snackbar.timeout);
    },

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///  API  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    resetPassword() {
      let auth = {
        token: this.token,
        email: this.email,
        passwordNew: this.password.password
      };

      //
      api
        .post(`/login/resetPassword`, auth)
        .then(response => {
          // // console.log(response.data);
          // snackbar
          window.scrollTo(0, 0);
          this.snackbar.color = "success";
          this.snackbar.text = this.$t("user.Password Changed to: ") + this.email;
          this.snackbarTimeout(2000);
          //
        })
        .catch(err => {
          // // console.log(err);
          this.mainButton.btnSaveDisabled = false;
          // snackbar
          err = err.data ? err.data : err;
          // // console.log("err.response  + " + err.response);
          if (err.response == undefined) {
            window.scrollTo(0, 0);
            this.snackbar.color = "error";
            this.snackbar.text = err + " => resetPassword";
            this.snackbar.show = true;
          } else {
            if (err.response.status == 404) {
              window.scrollTo(0, 0);
              this.snackbar.color = "warning";
              this.snackbar.text = this.$t("login.msgResetPassword");
              this.snackbar.show = true;
              //
            } else {
              window.scrollTo(0, 0);
              this.snackbar.color = "error";
              this.snackbar.text = err + " => resetPassword";
              this.snackbar.show = true;
            }
          }
        });
    }
  },
  /////////////////
  ///////////
  created() {
    if (localStorage.locale != undefined) {
      this.$i18n.locale = localStorage.locale;
    } else {
      this.$i18n.locale = window.navigator.language.toLowerCase();
    }
    document.title = this.$t("common." + this.$route.meta.title);
    //
    this.token = this.$route.query.t;
    this.email = this.$route.query.e;
    //
    localStorage.clear(); // old junk cleaner
  }
};
</script>
